module.exports = __webpack_public_path__ + "img/right-arrow.e10b26d7.png";